import axios from 'axios'
import VueCookies from 'vue-cookies'
import Vue from 'vue'
import {
	Message,
	Loading
} from 'element-ui'
Vue.use(VueCookies)
import router from './router/index.js'

import config from './config.js'

let loading;

const service = axios.create({
	baseURL:config.baseURL,
	// baseURL:"http://localhost:4500/",
	timeout: 30000 // request timeout
})
service.interceptors.request.use(
	config => {
		config.headers['token'] = VueCookies.get('token')
		loading = Loading.service({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
		return config
	}, error => {
		console.log(error) // for debug
		return Promise.reject(error)
	}
)
// response interceptor
service.interceptors.response.use(
	response => {
		const res = response.data
		console.log(res)
		loading.close()
		if (res.code == 2000) {
			return res
		}else if(res.code == 1001){
			Message({
				message: '账号未登录',
				type: 'error',
				duration: 5 * 1000
			})
			// location.reload()
			router.push({
				path:'/login'
			})
			return Promise.reject(res.message)
		} else {
			Message({
				message: res.msg,
				type: 'error',
				duration: 5 * 1000
			})
			return Promise.reject(res.message)
		}
	}, error => {
		console.log('err' + error) // for debug
		Message({
			message: '请求失败，请重试'+error,
			type: 'error',
			duration: 5 * 1000
		})
		loading.close()
		return Promise.reject(error)
	}
)
export default service
